<template>
  <div id="June2023" class="202306">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202305/menu/right.png" class="object-contain w-full">
      </a>
      <a class="cursor-default block px-3"><img src="~@/assets/images/202306/menu/menu-off_01.png" class="object-contain"></a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section2')">
        <img src="~@/assets/images/202306/menu/menu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202306/menu/menu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section3')">
        <img src="~@/assets/images/202306/menu/menu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202306/menu/menu-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section4')">
        <img src="~@/assets/images/202306/menu/menu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202306/menu/menu-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#June2023')">
        <img src="~@/assets/images/202306/menu/menu-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202306/menu/menu-on_05.png" class="on object-contain">
      </a>
    </div>
    <main class="main mx-auto">
      <section id="section1" class="section1">
        <div class="py-3 lg:py-6 main-red-bg w-full"></div>

        <div class="topBg"></div>

        <div class="flex container py-3 pb-8 lg:py-6 flex-wrap md:flex-no-wrap">
          <div class="w-full md:w-auto px-2">
            <div><img src="~@/assets/images/202306/00-master-title.png" class="object-contain block"></div>
            <div><img src="~@/assets/images/202306/00-buger+mg.png" class="object-contain block"></div>
          </div>
          <div class="px-2">
            <div><img src="~@/assets/images/202306/00-gift-2500.png" class="object-contain block"></div>
            <div class="-mt-6 lg:mt-0"><img src="~@/assets/images/202306/00-images-date.png" class="object-contain block"></div>
          </div>
        </div>

        <div class="flex flex-wrap">
          <div @click="toTop('#section2')" class="w-full md:w-5/12 main-red-bg flex items-center p-3 md:pr-6 justify-end py-8 cursor-pointer">
            <div><img src="~@/assets/images/202306/00-plan-a.png" class="object-contain block"></div>
          </div>
          <div @click="toTop('#section3')" class="w-1/2 md:w-3/12 main-red-bg border-t-4 md:border-t-0 md:border-l-4 border-white border-r-4 flex items-center justify-center p-3 md:py-8 cursor-pointer">
            <div><img src="~@/assets/images/202306/00-plan-b.png" class="object-contain block"></div>
          </div>
          <div @click="toTop('#section4')" class="w-1/2 md:w-4/12 main-red-bg flex items-center pl-6 py-8 border-t-4 md:border-t-0 cursor-pointer">
            <div><img src="~@/assets/images/202306/00-plan-c.png" class="object-contain block"></div>
          </div>
        </div>
      </section>

      <!-- 01. 最省雜誌訂閱組合 -->
      <section id="section2" class="section2 container py-10 lg:px-6">
        <div>
          <img src="~@/assets/images/202306/01-tittle-01.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202306/m/01titile_m.png" class="object-contain block mx-auto md:hidden">
        </div>
        <div class="flex pt-3 lg:pt-10 lg:px-8 xl:px-12 flex-col md:flex-row">

          <div class="w-full md:w-5/12 pt-6 md:px-3 xl:px-8 md:hidden mb-4">
              <div class="px-4 flex">
                <p class="font-black leading-loose whitespace-no-wrap w-8/12 text-center">全系列雜誌10期（６刊選１）<br/>+ 必勝客6吋個人披薩特價</p>
                <div class="w-4/12"><img src="~@/assets/images/202306/01-images-01.png" class="object-contain block"></div>
              </div>

              <div class="px-4 flex items-center py-4">
                <p class="w-2/3">$<span class="text-5xl mx-2 font-black text-main-color">1,680</span> <span>原價</span><span class="line-through">$2285</span></p>
                <a href="https://store.liveabc.com/products/magazine/sale?tag=252" class="main-red-bg text-white text-sm px-4 py-3 md:px-12 rounded-full shadow-md">我要訂閲＞</a>
              </div>

              <p class="leading-loose px-4 text-sm">注意事項 : 必勝客6吋個人披薩內容為「六吋個人鬆厚夏威夷/雙層美式臘腸比薩一個(二選一)，為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「必勝客六吋個人鬆厚比薩二選一即享券」，將於2023.7.7前統一以簡訊方式寄出。</p>

          </div>

          <div class="flex flex-wrap w-full md:w-7/12 px-2">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2 lg:p-5 w-1/2 md:w-1/3" v-for="(item, index) in planData" :key="index">
              <img :src="item.img_url" class="object-contain">

              <p class="text-xs mb-1">{{ item.grade }}</p>
              <p class="text-md font-black">{{ item.title }}</p>
            </router-link>
          </div>

          <div class="w-full md:w-5/12 px-2 md:px-3 xl:px-8 hidden md:block">
            <a href="https://store.liveabc.com/products/magazine/sale?tag=245" class="block">
              <p class="font-black leading-loose text-lg xl:text-xl">全系列雜誌10期（６刊選１）<br/>+ 必勝客6吋個人披薩特價</p>

              <p class="mb-3">$<span class="text-5xl mx-2 font-black text-main-color">1,680</span> <span>原價</span><span class="line-through">$2285</span> </p>

              <div class="mb-3">
                <a href="https://store.liveabc.com/products/magazine/sale?tag=252" class="main-red-bg text-white text-sm py-3 px-16 rounded-full shadow-md inline-block">我要訂閲＞</a>
              </div>

              <p class="leading-loose">注意事項 : 必勝客6吋個人披薩內容為「六吋個人鬆厚夏威夷/雙層美式臘腸比薩一個(二選一)，為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「必勝客六吋個人鬆厚比薩二選一即享券」，將於2023.7.7前統一以簡訊方式寄出。</p>
            </a>

            <div class="justify-end px-8 flex mt-3">
              <div><img src="~@/assets/images/202306/01-images-01.png" class="object-contain block"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 02. 加購最省 66折 -->
      <section id="section3" class="section3 py-6 container px-6 mb-10">
        <div class="section3-outer">
          <div class="md:-mt-2">
            <img src="~@/assets/images/202306/02-tittle-01.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202306/m/02titile_m.png" class="object-contain block mx-auto md:hidden">
          </div>
          <div class="flex p-6 lg:py-10 lg:px-10 lg:hidden flex-wrap">
            <div class="flex items-center w-full">
              <div class="w-9/12">
                <p>※ 限訂閱雜誌之訂戶加購</p>
                <p class="text-xl mb-4"><span class="font-semibold">LiveABC 智慧點讀筆16G</span><br/>（Type-C 充電版）</p>

              </div>
              <div class="flex items-end w-3/12"><img src="~@/assets/images/202306/02-images-01.png" class="object-contain block"></div>
            </div>

            <div class="flex items-center mb-3">
                <p class="mb-3 whitespace-no-wrap w-9/12">$<span class="text-5xl mx-2 font-black text-main-color">1,790</span> <span>原價</span><span class="line-through">$2690</span> </p>
                <a href="https://store.liveabc.com/book/detail/6743" class="w-3/12"><img src="~@/assets/images/202306/Group 2.png" class="object-contain block"></a>
            </div>
            <div class="w-full flex">
              <div><img src="~@/assets/images/202306/02-babo-02.png" class="object-contain block"></div>
              <div><img src="~@/assets/images/202306/02-livepen.png" class="object-contain block"></div>
              <!-- <div class="flex items-end"><img src="~@/assets/images/202306/02-images-01.png" class="object-contain block"></div> -->
            </div>
          </div>
          <div class="p-6 lg:py-10 lg:px-10 hidden lg:flex">
            <div class="w-5/12 flex flex-col items-center">
              <div>
                <div class="mb-4"><img src="~@/assets/images/202306/02-babo-01.png" class="object-contain block"></div>
                <p class="text-xl mb-4"><span class="font-semibold">LiveABC 智慧點讀筆16G</span><br/>（Type-C 充電版）</p>
                <p class="mb-3">$<span class="text-5xl mx-2 font-black text-main-color">1,790</span> <span>原價</span><span class="line-through">$2690</span> </p>
                <a href="https://store.liveabc.com/book/detail/6743"><img src="~@/assets/images/202306/Group 2.png" class="object-contain block"></a>
              </div>
            </div>
            <div class="w-7/12 flex">
              <div><img src="~@/assets/images/202306/02-livepen.png" class="object-contain block"></div>
              <div><img src="~@/assets/images/202306/02-babo-02.png" class="object-contain block"></div>
              <div class="flex items-end"><img src="~@/assets/images/202306/02-images-01.png" class="object-contain block"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- 03. 單書任選４本 69折 -->
      <section id="section4" class="py-6">
        <div class="-mt-10">
          <img src="~@/assets/images/202306/03-tittle-01.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202306/m/03titile_m.png" class="object-contain block mx-auto md:hidden">
        </div>

        <div class="section4-outer pt-24 -mt-12 pb-6">
          <div class="py-6 container">
            <img src="~@/assets/images/202306/03-title-02.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202306/m/03-title-02-mobile.png" class="object-contain block mx-auto md:hidden">
          </div>

          <div class="flex flex-wrap container">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in bookData" :key="idx">

              <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                <div class="item relative main-red-orange py-6 md:rounded">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="price event_text tracking-wider font-semibold">
                  <p class="font-semibold text-sm md:text-base">{{ item.text }}</p>
                  <div class="border-b border-dotted my-2 md:my-3"></div>
                  <p>69折特價 $<span class="text-2xl text-main-color">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}</span></p>
                </div>
              </div>
            </router-link>
          </div>

          <a href="https://store.liveabc.com/products/magazine/sale?tag=255" class="mx-auto mt-6 hidden md:block mb-6 container"><img src="~@/assets/images/202306/button-more.png" class="object-contain block mx-auto"></a>

          <div class="py-6 container">
            <img src="~@/assets/images/202306/03-title-03.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202306/m/03-title-03-mobile.png" class="object-contain block mx-auto md:hidden">
          </div>
          <div class="flex flex-wrap container">
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in bookData2" :key="idx">

              <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                <div class="item relative main-red-green py-6 md:rounded">
                  <div class="outer mb-2">
                    <div class="inner mx-auto border-0 absolute w-full h-full">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                      <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                    </div>
                  </div>
                </div>

                <div class="price event_text tracking-wider font-semibold">
                  <p class="font-semibold text-sm md:text-base">{{ item.text }}</p>
                  <div class="border-b border-dotted my-2 md:my-3"></div>
                  <p>69折特價 $<span class="text-main-color text-2xl">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}</span></p>
                </div>
              </div>
            </router-link>
          </div>
          <a href="https://store.liveabc.com/products/magazine/sale?tag=256" class="mx-auto mt-6 hidden md:block container"><img src="~@/assets/images/202306/button-more.png" class="object-contain block mx-auto"></a>
        </div>
      </section>

      <section class="footer py-6 pb-10 main-text-color text-shadow container">
        <div class="container px-4 pl-8">
          <h6 class="text-xl lg:text-2xl mb-4 font-semibold">注意事項</h6>
          <ul class="list-decimal list-outside leading-loose text-base">
            <li>凡於活動期間2023.6.1~6.30內，官網消費單筆訂單滿2,500元，就送「3D全景英語圖解大百科(點讀精裝版)」，贈品數量有限，送完為止。</li>
            <li>訂閱『全系列雜誌10期(６刊選１)+ 必勝客6吋個人披薩』之訂戶，其票券為LiveABC向Ticket Xpress即享券企業禮贈平台購買之「必勝客六吋個人鬆厚比薩二選一即享券」，將於2023.7.7前統一以簡訊方式寄出。</li>
            <li>本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
            <li>活動以官網公告為主，凡有變更則不另加通知。</li>
          </ul>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'May2023',
  metaInfo () {
    return {
      title: '訂雜誌 學英語 LiveABC請你吃披薩! 畢業季精打細算全攻略',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      renderComponent: false,
      planData: [
        { name: 'ABC', id: 8581, grade: '初級 / 基礎 / 活用', title: 'ABC互動英語', type: 'abc', img_url: require('@/assets/images/202306/ABC-COVER.png') },
        { name: 'LIVE', id: 8582, grade: '中級 / 生活 / 實用', title: 'Live互動英語', img_url: require('@/assets/images/202306/Live-COVER.png') },
        { name: 'ALL', id: 8583, grade: '中高級 / 進階 / 應用', title: 'ALL+互動英語', img_url: require('@/assets/images/202306/ALL-COVER.png') },
        { name: 'CNN', id: 8584, grade: '新聞 / 時事 / 新知', title: 'CNN互動英語', type: 'cnn', img_url: require('@/assets/images/202306/CNN-COVER.png') },
        { name: 'JP', id: 8585, grade: '初級 / 生活 / 實用', title: '互動日本語', type: 'jp', img_url: require('@/assets/images/202306/JP-COVER.png') },
        { name: 'HW', id: 8586, grade: '圖解｜百科｜符合108課綱', title: '知識大圖解', type: 'hiw', img_url: require('@/assets/images/202306/HIW-COVER.png') }
      ],

      bookData: [
        { id: 8313, text: '多益必考單字全都背起來' },
        { id: 7434, text: '快速Get新聞重點單字' },
        { id: 7161, text: '閱讀是英語學習的基礎' },
        { id: 7002, text: '網路社群用語快學起來' },
        { id: 7013, text: '理解英語片語用法' },
        { id: 6521, text: '生活中最常見的字彙百科' },
        { id: 7875, text: '收錄最想學的日語會話' },
        { id: 7732, text: '把日語說得恰到好處' },
        { id: 6874, text: '帶你學好道地的日語' },
        { id: 6263, text: '日文閱讀初學最佳入門書' },
        { id: 7401, text: '追劇時別忘了學韓語' },
        { id: 6873, text: '最具代表性的韓國流行語' }
      ],
      bookData2: [
        { id: 7955, text: '多益達人教你應考秘技' },
        { id: 7456, text: '提升英語聽力的高效訓練' },
        { id: 7399, text: '用心智圖聰明背單字' },
        { id: 6779, text: '剖析多益解題關鍵' },
        { id: 7647, text: '用英語表達想法及提案' },
        { id: 7560, text: '各種通訊往來的英語都在' },
        { id: 7137, text: '精通職場情境的關鍵用語' },
        { id: 6835, text: '教你會議中常用英語對話' },
        { id: 8166, text: '讓你的英語跟上世界趨勢' },
        { id: 8009, text: '職場生活都派得上用場' },
        { id: 7012, text: '簡報日語馬上開口說' },
        { id: 6573, text: '理解日本職場文化' }
      ]
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.bookData)
      await self.getData(self.bookData2)
    },
    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=20`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#June2023 {
  .main-red-bg {
    background: #F24405;
  }
  .main-red-orange {
    background: #F2A413;
  }
  .main-red-green {
    background: #C5D930;
  }
  .text-main-color {
    color: #F24405;
  }
  .topBg {
    height: 44px;
    width: 100%;
    background-image: url('~@/assets/images/202306/TOP2.png');
    background-repeat: repeat-x;
    @media (max-width: 640px) {
      background-size: 92px;
      height: 40px;
    }
  }
  .circle {
    left: 5%;
    top: 0;
    width: auto;
    @media (max-width: 1024px) {
      left: 3%;
      top: -17%;
      width: 80%;
    }
    @media (max-width: 996px) {
      left: 0%;
      top: -17%;
      width: 70%;
    }
    @media (max-width: 767px) {
      left: 5%;
      top: -17%;
      width: auto;
    }
  }
  .toggle-btn {
    top: 20%;
    left: -40%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 70%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  #section1 {
    background-image: url('~@/assets/images/202306/background-dot.png');
  }
  #section3 {
    .section3-outer {
      background: #FFF2B2;
      border-radius: 52px;
      border: 4px solid #F24405;
      @media (max-width: 1440px) {
        border-radius: 0px;
        border: none;
      }
    }
  }
  #section4 {
    .section4-outer {
      background: rgb(255, 242, 179, 0.35);
      @media (max-width: 1440px) {
        background: white;
      }
    }
  }
}
</style>
